import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import PlanProcessBar from '../../../../components/ProcessBar/PlanProcessBar';
import InfoBox from '../../../../components/InfoBox/InfoBox';
import ScenarioHub from './components/ScenarioHub/ScenarioHub';
import ScenarioWalkthrough from './components/ScenarioWalkthrough/ScenarioWalkthrough';
import { getPartnerAccent } from '../../../../themes/partnerTheme';
import { getBcmLabels } from '../Plan/planSections';
import { dashboardContentVariantSelector } from '../../../Organisation/OrganisationSelectors';
import './TestingExercising.scss';

const BASE_PATH = '/dashboard/testing-exercising';

function TestingExercising({ planScreenTitle, dashboardContentVariant }) {
  const accentColor = getPartnerAccent('validation');
  const { validation: validationLabel } = getBcmLabels(dashboardContentVariant);
  const title = planScreenTitle || validationLabel || 'Testing & Exercising';

  return (
    <>
      <PlanProcessBar color={accentColor} title={title} />
      <InfoBox
        color={accentColor}
        guidance={
          <>
            <strong>What to do:</strong> select a scenario, click <strong>Start walkthrough</strong>, then work through
            each video with your team and capture responses before submitting.
          </>
        }
        message="Use scenario walkthroughs to validate that your teams can execute the Business Continuity Plan under realistic pressure."
      />
      {/* `--te-accent` drives every accent-tinted state in TestingExercising.scss. */}
      <div className="component-wrapper testing-exercising" style={{ '--te-accent': accentColor }}>
        <Switch>
          <Route
            exact
            path={BASE_PATH}
            render={() => <ScenarioHub accentColor={accentColor} />}
          />
          <Route
            path={`${BASE_PATH}/scenarios/:scenarioId/submissions/:submissionId`}
            render={() => <ScenarioWalkthrough accentColor={accentColor} />}
          />
          <Redirect to={BASE_PATH} />
        </Switch>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  dashboardContentVariant: dashboardContentVariantSelector(state),
});

export default connect(mapStateToProps)(TestingExercising);
